import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import handshake from '../../core/session/handshake/actions';
import SessionStates from '../../core/session/session-states';
import Dashboard from '../../components/Dashboard';
import qsession from '../../core/session/queries';
import qcore from '../../core/queries';
import LoadingScreen from './LoadingScreen';

const FAREWELL_DURATION = 700;

function RootComponent(props) {
  const {
    init,
    token,
    applet,
    profile,
    isPublic,
    children,
    location,
    sessionState,
  } = props;
  const menu = profile && profile.get('menu');
  const config = profile && profile.get('parametros');
  const keepLoading =
    !config ||
    (!isPublic && (!profile || !token)) ||
    sessionState === SessionStates.SUSPENDED;

  React.useEffect(() => {
    init();
  }, []);

  // Transição final do loading: ao terminar o handshake e ter o Dashboard
  // pronto, seguramos por FAREWELL_DURATION mostrando "Pronto, vamos iniciar!"
  // pra suavizar a abertura. O timer fica em ref pra não ser cancelado pelo
  // cleanup do useEffect quando as deps reagem ao próprio setState.
  const willShowDashboard = !isPublic && Boolean(menu) && Boolean(profile) && Boolean(token);
  const farewellTimerRef = React.useRef(null);
  const [farewellDone, setFarewellDone] = React.useState(false);

  React.useEffect(() => {
    if (
      !keepLoading
      && willShowDashboard
      && !farewellDone
      && farewellTimerRef.current === null
    ) {
      farewellTimerRef.current = window.setTimeout(
        () => setFarewellDone(true),
        FAREWELL_DURATION,
      );
    }
  }, [keepLoading, willShowDashboard, farewellDone]);

  React.useEffect(() => () => {
    if (farewellTimerRef.current !== null) {
      window.clearTimeout(farewellTimerRef.current);
    }
  }, []);

  if (keepLoading) {
    return <LoadingScreen sessionState={sessionState} />;
  }
  if (willShowDashboard && !farewellDone) {
    return <LoadingScreen sessionState={sessionState} farewell />;
  }
  if (isPublic || !menu) {
    return <>{children}</>;
  }
  if (!profile || !token) {
    return <LoadingScreen />;
  }
  return (
    <Dashboard menu={menu} location={location} applet={applet}>
      {children}
    </Dashboard>
  );
}

function mapDispatchToProps(dispatch, ownProps) {
  const { isPublic, history } = ownProps;
  if (isPublic) {
    return bindActionCreators({ init: handshake.initPublic }, dispatch);
  }
  return bindActionCreators(
    { init: () => handshake.init(history.push) },
    dispatch,
  );
}

function mapStateToProps(state) {
  return {
    sessionState: qsession.getSessionState(state),
    profile: qsession.getUserProfile(state),
    config: qsession.getSystemParams(state),
    token: qsession.getToken(state),
    applet: qcore.getCurrentApplet(state),
  };
}

export default React.memo(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(RootComponent)),
);
